package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.addPathNodes
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.ativos.AnexoAtivo
import br.com.htms.inspeccaocampo.data.ativos.Ativo
import br.com.htms.inspeccaocampo.data.ativos.AtivosApi
import br.com.htms.inspeccaocampo.data.ativos.AtivosDados
import br.com.htms.inspeccaocampo.data.ativos.ChecklistDocsAtivo
import br.com.htms.inspeccaocampo.data.ativos.StatusAnexos
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.platform.decodeToImageBitmap
import br.com.htms.inspeccaocampo.ui.kit.PortalModal
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import kotlinx.coroutines.launch

private fun icone(nome: String, path: String): ImageVector =
    ImageVector.Builder(name = nome, defaultWidth = 24.dp, defaultHeight = 24.dp, viewportWidth = 24f, viewportHeight = 24f)
        .addPath(pathData = addPathNodes(path), fill = SolidColor(Color.Black))
        .build()

internal object IconesAnexo {
    val Imagem: ImageVector by lazy {
        icone(
            "Imagem",
            "M21,19V5c0,-1.1 -0.9,-2 -2,-2H5c-1.1,0 -2,0.9 -2,2v14c0,1.1 0.9,2 2,2h14c1.1,0 2,-0.9 2,-2zM8.5,13.5l2.5,3.01L14.5,12l4.5,6H5l3.5,-4.5z"
        )
    }
    val Documento: ImageVector by lazy {
        icone(
            "Documento",
            "M14,2H6c-1.1,0 -1.99,0.9 -1.99,2L4,20c0,1.1 0.89,2 1.99,2H18c1.1,0 2,-0.9 2,-2V8l-6,-6zM16,18H8v-2h8v2zM16,14H8v-2h8v2zM13,9V3.5L18.5,9H13z"
        )
    }
    val Contrato: ImageVector by lazy {
        icone(
            "Contrato",
            "M19,3h-4.18C14.4,1.84 13.3,1 12,1c-1.3,0 -2.4,0.84 -2.82,2H5c-1.1,0 -2,0.9 -2,2v14c0,1.1 0.9,2 2,2h14c1.1,0 2,-0.9 2,-2V5c0,-1.1 -0.9,-2 -2,-2zM12,3c0.55,0 1,0.45 1,1s-0.45,1 -1,1 -1,-0.45 -1,-1 0.45,-1 1,-1zM14,17H7v-2h7v2zM17,13H7v-2h10v2zM17,9H7V7h10v2z"
        )
    }
    val Clipe: ImageVector by lazy {
        icone(
            "Anexar",
            "M16.5,6v11.5c0,2.21 -1.79,4 -4,4s-4,-1.79 -4,-4V5c0,-1.38 1.12,-2.5 2.5,-2.5s2.5,1.12 2.5,2.5v10.5c0,0.55 -0.45,1 -1,1s-1,-0.45 -1,-1V6H10v9.5c0,1.38 1.12,2.5 2.5,2.5s2.5,-1.12 2.5,-2.5V5c0,-2.21 -1.79,-4 -4,-4S7,2.79 7,5v12.5c0,3.04 2.46,5.5 5.5,5.5s5.5,-2.46 5.5,-5.5V6h-1.5z"
        )
    }
    val Baixar: ImageVector by lazy {
        icone("Baixar", "M19,9h-4V3H9v6H5l7,7 7,-7zM5,18v2h14v-2H5z")
    }
}

internal enum class GrupoAnexo(val chave: String, val rotulo: String) {
    FOTO("FOTO", "Fotos"),
    DOC("DOC", "Documentos"),
    CONTRATO("CONTRATO", "Contrato");

    val icone: ImageVector
        get() = when (this) {
            FOTO -> IconesAnexo.Imagem
            DOC -> IconesAnexo.Documento
            CONTRATO -> IconesAnexo.Contrato
        }

    fun ok(s: StatusAnexos): Boolean = when (this) {
        FOTO -> s.fotosOk
        DOC -> s.docsOk
        CONTRATO -> s.contratoOk
    }

    fun legenda(s: StatusAnexos): String = when (this) {
        FOTO -> "${s.fotos}/${StatusAnexos.FOTOS_MINIMAS}"
        DOC -> "${s.docsAtendidos}/${ChecklistDocsAtivo.itens.size}"
        CONTRATO -> if (s.contratos > 0) "${s.contratos}" else "0"
    }
}

@Composable
internal fun IconeStatus(ok: Boolean, tamanho: Int = 18) {
    Icon(
        if (ok) Icons.Filled.CheckCircle else Icons.Filled.Close,
        contentDescription = if (ok) "OK" else "Pendente",
        tint = if (ok) PortalCores.Verde else PortalCores.Vermelho,
        modifier = Modifier.size(tamanho.dp)
    )
}

/** Cabeçalho de coluna da tabela: ícone + nome do grupo. */
@Composable
internal fun CabecalhoAnexo(grupo: GrupoAnexo, modifier: Modifier) {
    Column(modifier, horizontalAlignment = Alignment.CenterHorizontally) {
        Icon(grupo.icone, contentDescription = null, tint = PortalCores.Navy, modifier = Modifier.size(16.dp))
        Text(
            if (grupo == GrupoAnexo.DOC) "Docs" else grupo.rotulo,
            style = MaterialTheme.typography.labelSmall,
            fontWeight = FontWeight.SemiBold,
            color = PortalCores.CinzaTexto,
            maxLines = 1
        )
    }
}

/** Célula clicável: ícone do grupo + ✓ verde / ✗ vermelho + contagem. Abre a janela de anexos. */
@Composable
internal fun CelulaAnexo(grupo: GrupoAnexo, status: StatusAnexos, modifier: Modifier = Modifier, onClick: () -> Unit) {
    val ok = grupo.ok(status)
    Box(modifier, contentAlignment = Alignment.Center) {
        Column(
            Modifier
                .clip(RoundedCornerShape(8.dp))
                .border(1.dp, (if (ok) PortalCores.Verde else PortalCores.Vermelho).copy(alpha = 0.35f), RoundedCornerShape(8.dp))
                .background((if (ok) PortalCores.Verde else PortalCores.Vermelho).copy(alpha = 0.06f))
                .clickable(onClick = onClick)
                .padding(horizontal = 6.dp, vertical = 4.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(grupo.icone, contentDescription = "Anexar ${grupo.rotulo.lowercase()}", tint = PortalCores.Navy, modifier = Modifier.size(16.dp))
                Spacer(Modifier.width(3.dp))
                IconeStatus(ok, 16)
            }
            Text(grupo.legenda(status), style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaTexto)
        }
    }
}

/** Versão para a lista compacta (celular): os três indicadores lado a lado. */
@Composable
internal fun ResumoAnexos(status: StatusAnexos, onAbrir: (GrupoAnexo) -> Unit) {
    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
        GrupoAnexo.entries.forEach { g -> CelulaAnexo(g, status) { onAbrir(g) } }
    }
}

private suspend fun usarAnexo(a: AnexoAtivo, visualizar: Boolean): String? =
    AtivosApi.baixarAnexo(a.id).fold(
        onSuccess = { bytes ->
            val nome = a.fileName.ifBlank { "anexo" }
            val path = PlatformFiles.join(PlatformFiles.cacheDir(), "${a.id}_$nome")
            PlatformFiles.writeBytes(path, bytes)
            val mime = a.contentType.ifBlank { "application/pdf" }
            br.com.htms.inspeccaocampo.platform.BackupSharePoint.semBackup {
                if (visualizar) PlatformFiles.viewFile(path, mime, nome) else PlatformFiles.shareFile(path, mime, nome)
            }
            null
        },
        onFailure = { "Não foi possível ${if (visualizar) "abrir" else "baixar"} o arquivo: ${it.message}" }
    )

private fun nomeDoCaminho(path: String, padrao: String): String =
    path.substringAfterLast('/').substringAfterLast('\\').substringBefore('?').takeIf { it.contains('.') } ?: padrao

/** Janela de anexos do ativo: fotos (mín. 4), checklist de documentos e contrato. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun AnexosAtivoDialog(
    ativo: Ativo,
    d: AtivosDados,
    grupoInicial: GrupoAnexo,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit,
    editar: Boolean = true
) {
    val scope = rememberCoroutineScope()
    var grupo by remember { mutableStateOf(grupoInicial) }
    var enviando by remember { mutableStateOf<String?>(null) }
    var erro by remember { mutableStateOf<String?>(null) }
    var removendo by remember { mutableStateOf<AnexoAtivo?>(null) }
    val novos = remember { mutableStateListOf<AnexoAtivo>() }
    val removidos = remember { mutableStateListOf<String>() }
    val naLocal = remember { mutableStateMapOf<String, Boolean>() }
    val miniaturas = remember { mutableStateMapOf<String, ImageBitmap?>() }

    val doServidor = d.anexosDe(ativo.id)
    val idsServidor = doServidor.map { it.id }.toSet()
    val anexos = (doServidor + novos.filter { it.id !in idsServidor }).filter { it.id !in removidos }
    val fotos = anexos.filter { it.grupo == "FOTO" }
    val contratos = anexos.filter { it.grupo == "CONTRATO" }
    val docsPorItem = anexos.filter { it.grupo == "DOC" }.groupBy { it.item }
    val naServidor = anexos.filter { it.grupo == "NA" }.map { it.item }.toSet()
    fun ehNa(item: String) = naLocal[item] ?: (item in naServidor)
    val status = StatusAnexos(
        fotos = fotos.size,
        docsAtendidos = ChecklistDocsAtivo.itens.count { (k, _) -> docsPorItem[k].orEmpty().isNotEmpty() || ehNa(k) },
        contratos = contratos.size
    )

    fun enviar(g: GrupoAnexo, item: String, nome: String, bytes: ByteArray) {
        enviando = if (g == GrupoAnexo.DOC) ChecklistDocsAtivo.itens.firstOrNull { it.first == item }?.second ?: g.rotulo else g.rotulo
        erro = null
        scope.launch {
            AtivosApi.enviarAnexo(ativo.id, g.chave, item, nome, bytes)
                .onSuccess {
                    novos.add(it)
                    if (item.isNotBlank()) naLocal[item] = false
                    recarregar()
                }
                .onFailure { erro = it.message ?: "Falha ao enviar o arquivo." }
            enviando = null
        }
    }

    fun escolherFoto(camera: Boolean) {
        scope.launch {
            PlatformServices.notifyPhotoPickerOpening()
            val foto = if (camera) PlatformServices.capturePhoto() else PlatformServices.pickImage()
            val bytes = foto?.let { PlatformServices.loadImageBytes(it.path) } ?: return@launch
            enviar(GrupoAnexo.FOTO, "", nomeDoCaminho(foto.path, "foto_${ativo.codigo}.jpg"), bytes)
        }
    }

    fun escolherDocumento(g: GrupoAnexo, item: String) {
        scope.launch {
            val doc = PlatformServices.pickDocument() ?: return@launch
            enviar(g, item, doc.name, doc.bytes)
        }
    }

    fun visualizar(a: AnexoAtivo) {
        scope.launch { usarAnexo(a, true)?.let { erro = it } }
    }

    fun baixar(a: AnexoAtivo) {
        scope.launch { usarAnexo(a, false)?.let { erro = it } }
    }

    PortalModal(onFechar = onFechar, larguraMax = 900.dp) {
        Column(Modifier.fillMaxWidth().clip(RoundedCornerShape(14.dp)).background(PortalCores.Cartao).padding(20.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(IconesAnexo.Clipe, contentDescription = null, tint = PortalCores.Navy, modifier = Modifier.size(22.dp))
                Spacer(Modifier.width(8.dp))
                Column(Modifier.weight(1f)) {
                    Text("Anexos do ativo ${ativo.codigo}", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, color = PortalCores.Navy)
                    Text(ativo.descricao, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto, maxLines = 1, overflow = TextOverflow.Ellipsis)
                }
                IconButton(onClick = onFechar) { Icon(Icons.Filled.Close, contentDescription = "Fechar", tint = PortalCores.Navy) }
            }

            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                GrupoAnexo.entries.forEach { g ->
                    FilterChip(
                        selected = grupo == g,
                        onClick = { grupo = g },
                        leadingIcon = { Icon(g.icone, contentDescription = null, modifier = Modifier.size(18.dp)) },
                        label = { Text("${g.rotulo} · ${g.legenda(status)}") },
                        trailingIcon = { IconeStatus(g.ok(status)) }
                    )
                }
            }

            enviando?.let {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    CircularProgressIndicator(Modifier.size(18.dp), strokeWidth = 2.dp)
                    Text("Enviando: $it...", style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                }
            }
            erro?.let { Text(it, color = PortalCores.Vermelho, style = MaterialTheme.typography.bodyMedium) }

            when (grupo) {
                GrupoAnexo.FOTO -> {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        IconeStatus(status.fotosOk, 22)
                        Spacer(Modifier.width(8.dp))
                        Text(
                            if (status.fotosOk) "${fotos.size} foto(s) anexada(s) — mínimo atendido."
                            else "${fotos.size} de ${StatusAnexos.FOTOS_MINIMAS} fotos mínimas. Faltam ${StatusAnexos.FOTOS_MINIMAS - fotos.size}.",
                            fontWeight = FontWeight.SemiBold,
                            color = if (status.fotosOk) PortalCores.Verde else PortalCores.Vermelho
                        )
                    }
                    LinearProgressIndicator(
                        progress = { (fotos.size.toFloat() / StatusAnexos.FOTOS_MINIMAS).coerceAtMost(1f) },
                        modifier = Modifier.fillMaxWidth(),
                        color = if (status.fotosOk) PortalCores.Verde else PortalCores.Laranja
                    )
                    Text(
                        "Sugestão: frente, traseira, laterais e placa de identificação. Somente imagens (JPEG ou PNG).",
                        style = MaterialTheme.typography.bodySmall,
                        color = PortalCores.CinzaTexto
                    )
                    if (editar) FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        if (PlatformServices.hasCamera) {
                            Button(onClick = { escolherFoto(true) }, enabled = enviando == null, colors = ButtonDefaults.buttonColors(containerColor = PortalCores.Marca)) {
                                Icon(IconesAnexo.Imagem, contentDescription = null, modifier = Modifier.size(18.dp))
                                Spacer(Modifier.width(6.dp))
                                Text("Tirar foto")
                            }
                        }
                        OutlinedButton(onClick = { escolherFoto(false) }, enabled = enviando == null) {
                            Icon(IconesAnexo.Clipe, contentDescription = null, tint = PortalCores.Navy, modifier = Modifier.size(18.dp))
                            Spacer(Modifier.width(6.dp))
                            Text("Anexar imagem", color = PortalCores.Navy)
                        }
                    }
                    FlowRow(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                        fotos.forEach { f ->
                            LaunchedEffect(f.id) {
                                if (!miniaturas.containsKey(f.id)) {
                                    miniaturas[f.id] = AtivosApi.baixarAnexo(f.id).getOrNull()?.let { decodeToImageBitmap(it) }
                                }
                            }
                            Box(
                                Modifier.size(130.dp).clip(RoundedCornerShape(10.dp))
                                    .border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp))
                                    .background(PortalCores.FundoPainel)
                                    .clickable { visualizar(f) },
                                contentAlignment = Alignment.Center
                            ) {
                                val bmp = miniaturas[f.id]
                                when {
                                    bmp != null -> Image(bmp, contentDescription = f.fileName, contentScale = ContentScale.Crop, modifier = Modifier.fillMaxSize())
                                    miniaturas.containsKey(f.id) -> Icon(IconesAnexo.Imagem, contentDescription = null, tint = PortalCores.CinzaClaro, modifier = Modifier.size(40.dp))
                                    else -> CircularProgressIndicator(Modifier.size(22.dp), strokeWidth = 2.dp)
                                }
                                Box(
                                    Modifier.align(Alignment.BottomStart).padding(4.dp).size(28.dp).clip(CircleShape)
                                        .background(Color.White.copy(alpha = 0.9f)).clickable { baixar(f) },
                                    contentAlignment = Alignment.Center
                                ) {
                                    Icon(IconesAnexo.Baixar, contentDescription = "Baixar foto", tint = PortalCores.Navy, modifier = Modifier.size(16.dp))
                                }
                                if (editar && d.podeRemoverAnexo(f)) {
                                    Box(
                                        Modifier.align(Alignment.TopEnd).padding(4.dp).size(28.dp).clip(CircleShape)
                                            .background(Color.White.copy(alpha = 0.9f)).clickable { removendo = f },
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Icon(Icons.Filled.Delete, contentDescription = "Remover foto", tint = PortalCores.Vermelho, modifier = Modifier.size(18.dp))
                                    }
                                }
                            }
                        }
                        repeat((StatusAnexos.FOTOS_MINIMAS - fotos.size).coerceAtLeast(0)) {
                            Box(
                                Modifier.size(130.dp).clip(RoundedCornerShape(10.dp))
                                    .border(BorderStroke(1.dp, PortalCores.Vermelho.copy(alpha = 0.4f)), RoundedCornerShape(10.dp))
                                    .clickable(enabled = editar && enviando == null) { escolherFoto(false) },
                                contentAlignment = Alignment.Center
                            ) {
                                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                    Icon(IconesAnexo.Imagem, contentDescription = null, tint = PortalCores.Vermelho.copy(alpha = 0.6f), modifier = Modifier.size(32.dp))
                                    Text("Foto pendente", style = MaterialTheme.typography.labelSmall, color = PortalCores.Vermelho)
                                }
                            }
                        }
                    }
                }

                GrupoAnexo.DOC -> {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        IconeStatus(status.docsOk, 22)
                        Spacer(Modifier.width(8.dp))
                        Text(
                            "Documentos básicos de máquinas e equipamentos — ${status.docsAtendidos} de ${ChecklistDocsAtivo.itens.size} itens atendidos",
                            fontWeight = FontWeight.SemiBold,
                            color = if (status.docsOk) PortalCores.Verde else PortalCores.Navy
                        )
                    }
                    Text(
                        "Cada item fica OK quando tem arquivo anexado (PDF, JPEG ou PNG) ou quando é marcado como \"Não se aplica\" (ex.: CRLV para equipamento que não é veículo).",
                        style = MaterialTheme.typography.bodySmall,
                        color = PortalCores.CinzaTexto
                    )
                    Column(Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp))) {
                        Row(
                            Modifier.fillMaxWidth().background(PortalCores.CabecalhoTabela, RoundedCornerShape(topStart = 10.dp, topEnd = 10.dp))
                                .padding(horizontal = 12.dp, vertical = 10.dp)
                        ) {
                            Text("Itens", Modifier.weight(1f), fontWeight = FontWeight.Bold, color = PortalCores.Navy)
                            Text("Situação", fontWeight = FontWeight.Bold, color = PortalCores.Navy)
                        }
                        ChecklistDocsAtivo.itens.forEach { (chave, rotulo) ->
                            val arquivos = docsPorItem[chave].orEmpty()
                            val na = ehNa(chave) && arquivos.isEmpty()
                            val ok = arquivos.isNotEmpty() || na
                            HorizontalDivider(color = PortalCores.Borda)
                            Column(Modifier.fillMaxWidth().padding(horizontal = 12.dp, vertical = 8.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Text(rotulo, Modifier.weight(1f), style = MaterialTheme.typography.bodyMedium)
                                    Spacer(Modifier.width(8.dp))
                                    if (na) {
                                        Text("N/A", fontWeight = FontWeight.Bold, color = PortalCores.CinzaTexto, modifier = Modifier.padding(end = 4.dp))
                                    }
                                    IconeStatus(ok, 22)
                                }
                                FlowRow(
                                    horizontalArrangement = Arrangement.spacedBy(6.dp),
                                    verticalArrangement = Arrangement.spacedBy(2.dp)
                                ) {
                                    if (editar) TextButton(onClick = { escolherDocumento(GrupoAnexo.DOC, chave) }, enabled = enviando == null) {
                                        Icon(IconesAnexo.Clipe, contentDescription = null, modifier = Modifier.size(16.dp))
                                        Spacer(Modifier.width(4.dp))
                                        Text("Anexar")
                                    }
                                    if (editar && arquivos.isEmpty()) {
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Checkbox(
                                                checked = na,
                                                onCheckedChange = { marcar ->
                                                    naLocal[chave] = marcar
                                                    scope.launch {
                                                        AtivosApi.naoAplica(ativo.id, chave, marcar)
                                                            .onSuccess { recarregar() }
                                                            .onFailure {
                                                                naLocal.remove(chave)
                                                                erro = it.message ?: "Falha ao salvar."
                                                            }
                                                    }
                                                }
                                            )
                                            Text("Não se aplica", style = MaterialTheme.typography.bodySmall)
                                        }
                                    }
                                    arquivos.forEach { arq ->
                                        ArquivoAnexo(arq, editar && d.podeRemoverAnexo(arq), { visualizar(arq) }, { baixar(arq) }) { removendo = arq }
                                    }
                                }
                            }
                        }
                    }
                }

                GrupoAnexo.CONTRATO -> {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        IconeStatus(status.contratoOk, 22)
                        Spacer(Modifier.width(8.dp))
                        Text(
                            if (status.contratoOk) "Contrato anexado." else "Nenhum contrato anexado.",
                            fontWeight = FontWeight.SemiBold,
                            color = if (status.contratoOk) PortalCores.Verde else PortalCores.Vermelho
                        )
                    }
                    Text(
                        "Contrato de locação/compra, aditivos ou termo de responsabilidade. PDF, JPEG ou PNG (máx. 15 MB).",
                        style = MaterialTheme.typography.bodySmall,
                        color = PortalCores.CinzaTexto
                    )
                    if (editar) Button(
                        onClick = { escolherDocumento(GrupoAnexo.CONTRATO, "") },
                        enabled = enviando == null,
                        colors = ButtonDefaults.buttonColors(containerColor = PortalCores.Marca)
                    ) {
                        Icon(IconesAnexo.Contrato, contentDescription = null, modifier = Modifier.size(18.dp))
                        Spacer(Modifier.width(6.dp))
                        Text("Anexar contrato")
                    }
                    FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                        contratos.forEach { arq ->
                            ArquivoAnexo(arq, editar && d.podeRemoverAnexo(arq), { visualizar(arq) }, { baixar(arq) }) { removendo = arq }
                        }
                    }
                }
            }
        }
    }

    removendo?.let { arq ->
        AlertDialog(
            onDismissRequest = { removendo = null },
            title = { Text("Remover arquivo?") },
            text = { Text("\"${arq.fileName}\" será removido deste ativo.") },
            confirmButton = {
                TextButton(onClick = {
                    removendo = null
                    scope.launch {
                        AtivosApi.removerAnexo(arq.id)
                            .onSuccess {
                                removidos.add(arq.id)
                                avisar("Arquivo removido.")
                                recarregar()
                            }
                            .onFailure { erro = it.message ?: "Falha ao remover." }
                    }
                }) { Text("Remover", color = PortalCores.Vermelho) }
            },
            dismissButton = { TextButton(onClick = { removendo = null }) { Text("Cancelar") } }
        )
    }
}

@Composable
private fun ArquivoAnexo(
    a: AnexoAtivo,
    podeRemover: Boolean,
    onVisualizar: () -> Unit,
    onBaixar: () -> Unit,
    onRemover: () -> Unit
) {
    Row(
        Modifier.clip(RoundedCornerShape(8.dp)).background(PortalCores.AzulClaro).padding(start = 8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            if (a.ehImagem) IconesAnexo.Imagem else IconesAnexo.Documento,
            contentDescription = null,
            tint = PortalCores.Navy,
            modifier = Modifier.size(16.dp)
        )
        Text(
            a.fileName.ifBlank { "arquivo" },
            Modifier.widthIn(max = 220.dp).padding(horizontal = 6.dp, vertical = 6.dp),
            style = MaterialTheme.typography.bodySmall,
            color = PortalCores.Navy,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        TextButton(onClick = onVisualizar) { Text("Visualizar") }
        TextButton(onClick = onBaixar) { Text("Baixar") }
        if (podeRemover) {
            Box(Modifier.size(28.dp).clickable(onClick = onRemover), contentAlignment = Alignment.Center) {
                Icon(Icons.Filled.Close, contentDescription = "Remover", tint = PortalCores.Vermelho, modifier = Modifier.size(16.dp))
            }
        }
    }
}

internal enum class FiltroAnexo(val rotulo: String, val pendencia: Boolean) {
    TODOS("Todos", false),
    PENDENTE("Com pendência", true),
    FOTO("Fotos faltando", true),
    DOC("Documentos faltando", true),
    CONTRATO("Contrato faltando", true),
    COMPLETO("Completos", false);

    val icone: ImageVector?
        get() = when (this) {
            FOTO -> IconesAnexo.Imagem
            DOC -> IconesAnexo.Documento
            CONTRATO -> IconesAnexo.Contrato
            PENDENTE -> IconesAnexo.Clipe
            else -> null
        }

    fun atende(s: StatusAnexos): Boolean = when (this) {
        TODOS -> true
        PENDENTE -> !(s.fotosOk && s.docsOk && s.contratoOk)
        FOTO -> !s.fotosOk
        DOC -> !s.docsOk
        CONTRATO -> !s.contratoOk
        COMPLETO -> s.fotosOk && s.docsOk && s.contratoOk
    }
}

/** Filtro da lista por situação dos anexos, com a quantidade de ativos em cada opção. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun FiltroAnexos(ativos: List<Ativo>, d: AtivosDados, selecionado: FiltroAnexo, onSelect: (FiltroAnexo) -> Unit) {
    val status = ativos.map { d.statusAnexos(it.id) }
    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
        Text("Anexos (fotos, documentos e contrato)", style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
        FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            FiltroAnexo.entries.forEach { f ->
                val qtd = status.count { f.atende(it) }
                val cor = when {
                    f == FiltroAnexo.TODOS -> PortalCores.Navy
                    f.pendencia -> if (qtd > 0) PortalCores.Vermelho else PortalCores.Verde
                    else -> PortalCores.Verde
                }
                FilterChip(
                    selected = selecionado == f,
                    onClick = { onSelect(if (selecionado == f) FiltroAnexo.TODOS else f) },
                    leadingIcon = f.icone?.let { ic -> { Icon(ic, contentDescription = null, tint = cor, modifier = Modifier.size(16.dp)) } }
                        ?: if (f == FiltroAnexo.COMPLETO) ({ IconeStatus(true, 16) }) else null,
                    label = { Text("${f.rotulo} ($qtd)", color = if (f == FiltroAnexo.TODOS) PortalCores.Navy else cor, fontWeight = FontWeight.SemiBold) }
                )
            }
        }
    }
}